var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 41,
    viewBox: "0 0 150 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2730_8723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.625 37.9212C18.3687 38.3125 16.0725 38.43 13.6975 38.7425L6.4525 17.805V39.6413C4.19625 39.875 2.1375 40.1875 0 40.5V0.5H6.0175L14.2513 23.1962V0.5H20.6262L20.625 37.9212ZM33.0962 15.1488C35.55 15.1488 39.3113 15.0312 41.5675 15.0312V21.2812C38.7563 21.2812 35.4712 21.2812 33.0962 21.3988V30.695C36.8175 30.4613 40.5387 30.1488 44.2987 30.0312V36.0462L26.7612 37.4137V0.5H44.2987V6.75H33.0962V15.1488ZM67.8538 6.75H61.2825V35.5C59.145 35.5 57.0075 35.5 54.9487 35.5775V6.75H48.3775V0.5H67.855L67.8538 6.75ZM78.1475 14.7188H86.8175V20.9688H78.1475V35.1488H71.9312V0.5H89.6275V6.75H78.1475V14.7188ZM99.92 29.68C103.524 29.7575 107.165 30.0312 110.689 30.2262V36.3988C105.028 36.0462 99.3663 35.695 93.5863 35.5775V0.5H99.92V29.68ZM116.032 36.8288C118.052 36.945 120.19 37.0625 122.249 37.2962V0.5H116.032V36.8288ZM150 0.5L141.964 19.5238L150 40.5C147.625 40.1875 145.249 39.7575 142.874 39.3675L138.321 27.805L133.69 38.43C131.394 38.0387 129.176 37.9212 126.881 37.6087L135.036 19.2887L127.673 0.5H134.481L138.638 11.0075L143.072 0.5H150Z",
    fill: "black",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2730_8723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame (2).aa5685e6a91a13c9cdc01cfbcab5759b.svg";
export { ForwardRef as ReactComponent };